/**
 * 默认校验规则表 —— 按字段名组织的额外校验规则
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：moduleFieldName（小驼峰，无连字符）
 * ═══════════════════════════════════════════════════════════
 *
 *  部分              含义                       示例
 * ─────────────────────────────────────────────────────────
 *  moduleFieldName   模块+字段名拼接             addressDetailAddr / orderPhone / commonPhone
 *
 * 多模块共用的校验规则，使用 "common" 前缀：
 *   例：commonPhone（地址/订单等都可能校验手机号）
 *
 * 国家层可追加同名字段的规则（数组 concat 合并，不替换）
 */
import { lang } from '@/utils'

/**
 * 默认密码校验正则
 * 密码长度8-20位，包含大小写字母数字等类型中两种
 */
export const PWD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/

/**
 * 默认密码校验规则
 */
export const pwdValidator = (_: any, value: string) => {
  if (value && !PWD_REG.test(value)) {
    return Promise.reject(lang('密码长度8-20位，包含大小写字母数字等类型中两种'))
  }
  return Promise.resolve()
}

export const FIELD_RULES: Record<string, any[]> = {
  /** 地址 - 详细地址字段的额外校验 */
  addressDetailAddr: [],

  /** 通用 - 手机号字段的额外校验 */
  commonPhone: [],

  /** 通用 - 密码字段的校验规则 */
  commonPassword: [{ validator: pwdValidator, trigger: ['change', 'blur'] }]
}
